export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: 20,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          borderRadius: 0,
          padding: '10px 40px',
          '&:hover': {
            boxShadow: 'none',
          },
          boxShadow: 'none',
          whiteSpace: 'nowrap',
        },
        sizeSmall: {
          height: 44,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
          '&.Mui-disabled': {
            background: theme.palette.primary.main,
            color: 'white',
            opacity: 0.2,
          },
        },
        outlinedPrimary: {
          backgroundColor: 'white',
          '&:hover': {
            backgroundColor: 'white',
            border: `1px solid ${theme.palette.primary.dark}`,
            color: theme.palette.primary.dark,
          },
          '&.Mui-disabled': {
            background: 'white',
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            opacity: 0.2,
          },
        },
        textPrimary: {
          fontWeight: 600,
          textDecoration: 'underline',
          '&:hover': {
            textDecoration: 'underline',
          },
          '&.Mui-disabled': {
            color: theme.palette.primary.main,
            opacity: 0.2,
          },
        },
      },
    },
  };
}
